import React from 'react';
import PropTypes from 'prop-types';
import AccountSupportAccordion from './AccountSupportAccordion';

const AccountSupportAccordionList = ({ collection }) => {
  const resources = collection?.resources().list();
  return resources?.map(resource => <AccountSupportAccordion key={resource.id()} resource={resource} />);
};

AccountSupportAccordionList.defaultProps = {
};

AccountSupportAccordionList.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default AccountSupportAccordionList;
